// extracted by mini-css-extract-plugin
module.exports = {"link":"Links_link__2EvQa","customBtn":"Links_customBtn__3iFFK","boton":"Links_boton__3pNV-","activo":"Links_activo__EHVaW"};